// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"641":"3b4bffb9","744":"fba1233f","791":"c524933a","856":"5bc8fe10"}[chunkId] + ".chunk.js";
};